"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenFeedbackBenefitDialog = exports.Name = exports.FeedbackBenefitBannerType = void 0;
let FeedbackBenefitBannerType = exports.FeedbackBenefitBannerType = /*#__PURE__*/function (FeedbackBenefitBannerType) {
  FeedbackBenefitBannerType["Cashback"] = "Cashback";
  FeedbackBenefitBannerType["ShareAndEarn"] = "ShareAndEarn";
  return FeedbackBenefitBannerType;
}({});
const Name = exports.Name = 'open-feedback-benefit-dialog';
const OpenFeedbackBenefitDialog = exports.OpenFeedbackBenefitDialog = Name;
